<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

  <full-calendar style="padding: 20px 20px;" [options]="calendarOptions"></full-calendar>
  <div [ngClass]="{
    'header-panel-sidebar': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'header-panel-horizontal': configService.config.menuMode === 'horizontal'}"
       class="flex flex-row" style="position: absolute;">
    <input pInputText
           style="margin-right: 20px;"
           type="text"
           class="search-input"
           [(ngModel)]="searchFilter"
           (input)="handleFilterChange()"
           placeholder="Search" />
    <p-multiSelect (onChange)="handleFilterChange()"
                   [options]="xpressCenters"
                   [(ngModel)]="selectedCenters"
                   defaultLabel="Select Centers"
                   optionLabel="Name"
                   selectedItemsLabel="{0} items selected"></p-multiSelect>
  </div>
</div>
